<script>
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import BlogCardListView from "../blog/blogCardListView.vue";
import DrawerAside from "../package/DrawerAside.vue";
import HeaderSection from "../package/HeaderSection.vue";
import FooterSection from "../package/footerSection.vue";


export default {
  name: "blogLayout",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    }
  },
  components: {
    FooterSection,
    HeaderSection, DrawerAside, BlogCardListView,
    // MobileAppDownload
  },
  methods: {
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    }
  },
  beforeUpdate() {
    document.title = "UNIFI Property: News";
  },
  created() {
    document.title = "UNIFI Property: News";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
}
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;;margin-top: 6px;">
        <el-row>
          <el-col :span="24">
            <blog-card-list-view></blog-card-list-view>
          </el-col>
        </el-row>

<!--        <mobile-app-download/>-->
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/blog/blogLayout.vue